var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85545 8.5C7.85545 6.24722 9.75543 4.5 11.9994 4.5C14.2433 4.5 16.1433 6.24722 16.1433 8.5C16.1433 10.7528 14.2433 12.5 11.9994 12.5C9.75543 12.5 7.85545 10.7528 7.85545 8.5ZM11.9994 6.5C10.7706 6.5 9.85545 7.43907 9.85545 8.5C9.85545 9.56093 10.7706 10.5 11.9994 10.5C13.2281 10.5 14.1433 9.56093 14.1433 8.5C14.1433 7.43907 13.2281 6.5 11.9994 6.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.05011 8.18731C2.52459 3.70774 6.88881 0.5 12 0.5C17.1112 0.5 21.4754 3.70778 22.9499 8.18739L23.0528 8.50004L22.9498 8.81269C21.4754 13.2923 17.1111 16.5 12 16.5C6.88881 16.5 2.52456 13.2922 1.05011 8.81261L0.947205 8.49996L1.05011 8.18731ZM3.05949 8.49997C4.35366 11.9745 7.84972 14.5 12 14.5C16.1502 14.5 19.6463 11.9745 20.9405 8.50003C19.6463 5.02551 16.1502 2.5 12 2.5C7.84972 2.5 4.35368 5.02548 3.05949 8.49997Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.4bc664155d2f3b6b3beb028890f9c729.svg";
export { ForwardRef as ReactComponent };